"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NSMerchButton;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _button = _interopRequireDefault(require("@ux/button"));
var _core = require("@linaria/core");
var _index = require("../motion-functions/index.js");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _tracking = _interopRequireDefault(require("@site/pattern-library-utils/tracking"));
var _intentsConfig = _interopRequireDefault(require("./intents.config.js"));
/* eslint-disable complexity */
/* eslint-disable max-len */

const buttonStyles = "core-b15fsowq";
const getDesignNormalized = design => {
  let normalized;
  switch (design) {
    case 'merch':
      normalized = 'primary';
      break;
    case 'merch-secondary':
      normalized = 'secondary';
      break;
    default:
      normalized = design;
      break;
  }
  return normalized;
};

/**
  * Render action buttons
  * @module NSMerchButton
  *
  * @param {Object} props React props for for element
  * @param {string} props._name Sitecore item name for tracking
  * @param {String} props.text UXCore Button props
  * @param {bool} props.external if url should open a new tab
  * @param {Array} props.rels Array of rel strings
  * @param {string} props.windowOptions if url hould open a new tab (old to be removed)
  * @param {String} props.size UXCore Button props
  * @param {String} props.design UXCore Button props
  * @param {String} props.width UXCore Button props
  * @param {Boolean} props.inverted UXCore Button props
  * @param {String} props.ariaLabel UXCore Button props
  * @param {String} props.shrinkOn Mobile or Tablet Default Button Shrinks
  * @param {Function} props.onClick Forwarded Func (used by other Pattern Library components, not expected to be passed in from the CMS)
  * @param {Boolean} props.isPromo Use promo (default) or eid
  * @param {String} props.itemTrackingCode Use itemTrackingCode to add ITC Values to CTA
  * @param {object} props.trackingCustomProperties Custom properties object
  * @param {String} props.partial Theme partial
  * @returns {React.ReactElement} UXCore ButtonSet component
  * @public
  */
function NSMerchButton({
  dataCy = 'ns-merch-button',
  text,
  external,
  windowOptions,
  rels,
  size = 'small',
  design = 'primary',
  width = 'auto',
  inverted = false,
  anchor,
  anchorOffset,
  ariaLabel,
  _name,
  shrinkOn,
  onClick,
  href,
  isPromo = true,
  trackingCustomProperties = {},
  itemTrackingCode: fieldItc,
  partial,
  ...rest
}) {
  const isServerSideRender = (0, _patternLibraryUtils.useIsServerSideRender)();
  const normalizedDesign = getDesignNormalized(design);
  let anchorAttr, onClickAttr, urlItc;
  if (anchor) {
    anchorAttr = {
      'data-target': anchor
    };
    onClickAttr = {
      onClick: evt => {
        evt.preventDefault();
        (0, _patternLibraryUtils.scrollToAnchor)(evt.currentTarget, anchorOffset);
      }
    };
  } else if (onClick) {
    onClickAttr = {
      onClick: evt => {
        evt.preventDefault();
        onClick(evt);
      }
    };
  }
  if (href && !isServerSideRender && typeof URL !== 'undefined') {
    try {
      const buttonUrl = new URL(href);
      const {
        searchParams
      } = buttonUrl;
      urlItc = searchParams.get('itc');
      if (fieldItc || urlItc) {
        searchParams.set('itc', fieldItc || urlItc);
        href = buttonUrl.href;
        trackingCustomProperties = {
          ...trackingCustomProperties,
          item_tracking_code: fieldItc || urlItc
        };
      }
      // eslint-disable-next-line no-empty
    } catch {
      // left blank intentionally
    }
  }
  const targetAttr = external || windowOptions === '_blank' ? {
    target: '_blank',
    rel: (0, _patternLibraryUtils.arrToString)(rels)
  } : {};
  return /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({}, anchor ? {
    'data-target': anchor,
    'onClick': evt => {
      evt.preventDefault();
      (0, _patternLibraryUtils.scrollToAnchor)(evt.currentTarget, anchorOffset);
    },
    'href': '#'
  } : {}, href ? {
    href
  } : {}, {
    text: text,
    "data-cy": dataCy,
    design: normalizedDesign,
    "data-size": size,
    "data-width": width,
    "data-partial": partial || (inverted ? 'dark1' : ''),
    className: `${buttonStyles}`,
    "aria-label": ariaLabel,
    "data-shrink": shrinkOn
  }, _tracking.default.create(_name, true, isPromo, trackingCustomProperties), isPromo && trackingCustomProperties?.item_tracking_code ? {
    'data-creative-name': trackingCustomProperties?.item_tracking_code
  } : {}, rest, anchorAttr, onClickAttr, targetAttr));
}
NSMerchButton.propTypes = {
  text: _propTypes.default.string,
  external: _propTypes.default.bool,
  rels: _propTypes.default.array,
  windowOptions: _propTypes.default.string,
  design: _propTypes.default.oneOf(['inline', 'primary', 'secondary', 'merch', 'merch-secondary']),
  width: _propTypes.default.oneOf(['auto', 'full']),
  size: _propTypes.default.oneOf(['small', 'default']),
  inverted: _propTypes.default.bool,
  _name: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  anchor: _propTypes.default.string,
  anchorOffset: _propTypes.default.number,
  href: _propTypes.default.string,
  ariaLabel: _propTypes.default.string,
  shrinkOn: _propTypes.default.oneOf(['mobile', 'tablet', 'tabletLg']),
  onClick: _propTypes.default.func,
  isPromo: _propTypes.default.bool,
  itemTrackingCode: _propTypes.default.string,
  trackingCustomProperties: _propTypes.default.object,
  partial: _propTypes.default.string,
  ..._button.default.propTypes
};